import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#50C760") => (
    <path
        d="M10 2.5C11.5471 2.5 13.031 3.10753 14.125 4.18945C15.219 5.27139 15.833 6.73944 15.833 8.26953C15.8329 12.3127 12.296 15.6556 10.7305 16.9375C10.5056 17.1216 10.3931 17.2136 10.2256 17.2607C10.0954 17.2973 9.90355 17.2974 9.77344 17.2607C9.60657 17.2136 9.49333 17.1207 9.26953 16.9375C7.704 15.6556 4.16728 12.3125 4.16699 8.26953C4.16699 6.73944 4.78104 5.27139 5.875 4.18945C6.96894 3.10759 8.45297 2.50002 10 2.5ZM10 6.38867C8.7727 6.38867 7.77734 7.38403 7.77734 8.61133C7.77746 9.83853 8.77277 10.833 10 10.833C11.2272 10.833 12.2225 9.83853 12.2227 8.61133C12.2227 7.38403 11.2273 6.38867 10 6.38867Z"
        fill={color}
    />
)
export const MapPin: React.FC<IconProps> = ({color, size = 20,}) => (
    <IconWrapper {...{size, color, renderIcon}} viewBox={'0 0 20 20'}/>
)
